import React from 'react';
import BossSupervisorList from 'components/Tvendo/Sale/DataMaster/BossSupervisor/List.js';

export default function () {
  return <BossSupervisorList />;
}
